import React from "react";

interface DemoDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  title?: string;
}

const DemoDialog: React.FC<DemoDialogProps> = ({ 
  isOpen, 
  onClose, 
  message = "For sharing, please log in using an official account instead of a demo account.",
  title = "Demo Account"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-inputbox-color p-6 rounded-lg w-full max-w-md">
        <h3 className="text-white text-lg mb-4 text-center">
          {title}
        </h3>
        <p className="text-white text-center">
          {message}
        </p>
        <div className="mt-4">
          <button
            className="w-full bg-meicnbg-color text-white px-4 py-2 rounded hover:bg-gray-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoDialog;

